const CustomComponent = ({ Component }: any, props: any) => {
  return <Component {...props} />;
};

export default CustomComponent;
